import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { HttpClientModule } from '@angular/common/http';

import { IonicStorageModule, Storage } from '@ionic/storage-angular';
import { Md5 } from 'ts-md5/dist/md5';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { WarningModalPage } from './page/warning-modal/warning-modal.page';
import { SortPopoverPage } from './page/sort-popover/sort-popover.page';
import { BulkmenuPopoverPage } from './page/bulkmenu-popover/bulkmenu-popover.page';
import { FilemenuPopoverPage } from './page/filemenu-popover/filemenu-popover.page';
import { CloudselectorModalPage } from './page/cloudselector-modal/cloudselector-modal.page';
import { CreatedirModalPage } from './page/createdir-modal/createdir-modal.page';
import { DownloadModalPage } from './page/download-modal/download-modal.page';
import { PreviewModalPage } from './page/preview-modal/preview-modal.page';
import { FilemenuModalPage } from './page/filemenu-modal/filemenu-modal.page';
import { SortModalPage } from './page/sort-modal/sort-modal.page';
import { BulkmenuModalPage } from './page/bulkmenu-modal/bulkmenu-modal.page';
import { RenameModalPage } from './page/rename-modal/rename-modal.page';
import { TrashmenuPopoverPage } from './page/trashmenu-popover/trashmenu-popover.page';
import { TrashmenuModalPage } from './page/trashmenu-modal/trashmenu-modal.page';
import { TrashbulkmenuPopoverPage } from './page/trashbulkmenu-popover/trashbulkmenu-popover.page';
import { TrashbulkmenuModalPage } from './page/trashbulkmenu-modal/trashbulkmenu-modal.page';
import { SettingPopoverPage } from './page/setting-popover/setting-popover.page';
import { SettingModalPage } from './page/setting-modal/setting-modal.page';
import { ProfileeditModalPage } from './page/profileedit-modal/profileedit-modal.page';
import { DeletedeviceModalPage } from './page/login/modal/deletedevice-modal.page';

@NgModule({
  declarations: [
    AppComponent,
    WarningModalPage,
    SortPopoverPage,
    BulkmenuPopoverPage,
    FilemenuPopoverPage,
    CloudselectorModalPage,
    CreatedirModalPage,
    DownloadModalPage,
    PreviewModalPage,
    FilemenuModalPage,
    SortModalPage,
    BulkmenuModalPage,
    RenameModalPage,
    TrashmenuPopoverPage,
    TrashmenuModalPage,
    TrashbulkmenuPopoverPage,
    TrashbulkmenuModalPage,
    SettingPopoverPage,
    SettingModalPage,
    ProfileeditModalPage,
    DeletedeviceModalPage
  ],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
        mode: 'md'
    }),
    AppRoutingModule,
    HttpClientModule,
    IonicStorageModule.forRoot({
      driverOrder: ['indexeddb', 'websql']
    })
  ],
  providers: [
    Md5,
    Storage,
   { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
